

<template>
  <div class="invoiceApplyFor">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>发票申请编号：</span>
          <div>
            <el-input v-model="applyNo" placeholder="单行输入"></el-input>
          </div>
        </div>
        <div class="item">
          <span>发票申请时间：</span>
          <div>
            <el-date-picker
              v-model="invoiceTime"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="item">
          <span>发票类型：</span>
          <div>
            <el-select v-model="type" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>业务进度：</span>
          <div>
            <el-select v-model="status" placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 50px;"></span>
          <el-button type="primary" @click="handlePagePost()" size="small">搜索</el-button>
          <el-button type="danger" @click="reset" size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table :data="tableData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="applyNo" label="发票申请编号" width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="delivererName" label="业务交付商" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type" label="发票类型" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceAmount" label="价税合计总额(元)" width="130" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceTime" label="发票申请时间" width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="delivererStatus" label="业务进度" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="statusName" label="发票状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchantName" label="发票抬头" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="businessmenName" label="开票方" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="isPay" label="付款与否" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="text-align: center;">
                    <el-dropdown-item>
                      <el-button
                        @click="handleClick(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >查看详情</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '1000'">
                      <el-button
                        @click="auditHandleClick(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >发票审核</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '1020'">
                      <el-button
                        @click="newProgress(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >订单分配</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '1060'">
                      <el-button
                        @click="deliveryHandleClick(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >交付审核</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '1080'">
                      <el-button
                        @click="completeClick(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >&#12288;完成&#12288;</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <!-- 发票审核 -->
    <el-dialog title="发票申请审核" :visible.sync="dialogAudit" width="707px" :before-close="handleClose">
      <div class="dialogAudit">
        <div class="main">
          <div class="items2">
            <div class="text">发票金额：{{invoiceObj.invoiceAmount}}元</div>
          </div>
          <div class="items2">
            <div class="text">发票内容：{{invoiceObj.invoiceContent}}</div>
          </div>
          <div class="items2">
            <span>合同文件：</span>
            <div class="img">
              <img :src="invoiceObj.contract" alt />
            </div>
          </div>
          <div class="items2">
            <span>结算单：</span>
            <div class="img">
              <img :src="invoiceObj.settleImg" alt />
            </div>
          </div>
        </div>
        <div class="main2">
          <el-form
            :model="auditForm"
            :rules="auditRules"
            ref="auditForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="付款与否：" prop="isPay">
              <el-radio-group v-model="auditForm.isPay">
                <el-radio label="0">未付款</el-radio>
                <el-radio label="1">已付款</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="审核状态：" prop="nextStatus">
              <el-select v-model="auditForm.nextStatus" placeholder="请选择">
                <el-option label="审核通过" value="1020"></el-option>
                <el-option label="审核不通过" value="1010"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审核备注：" prop="remark">
              <el-input
                type="textarea"
                v-model="auditForm.remark"
                rows="4"
                resize="none"
                placeholder="请输入多行"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('auditForm')">确定</el-button>
              <el-button @click="resetForm('auditForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!-- 业务分配 -->
    <el-dialog title="业务分配" :visible.sync="dialogOrder" width="575px" :before-close="handleClose">
      <div style="width: 390px; margin: 0 auto; text-align: left;">
        <el-form
          ref="distributionForm"
          :model="distributionForm"
          :rules="rulesTwo"
          label-width="110px"
        >
          <el-form-item label="交付商：" prop="delivererId">
            <div style="width:233px">
              <el-select
                v-model="distributionForm.delivererId"
                style="width:100%"
                placeholder="请选择"
                @change="distributionChange"
              >
                <el-option
                  v-for="item in distributionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="交付商分成：" prop="delivererAmount">
            <div style="width:233px">
              <el-input v-model="distributionForm.delivererAmount" type="number"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="distributionSubmit('distributionForm')">确定</el-button>
            <el-button @click="distributionResetForm('distributionForm')">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 发票审核 -->
    <el-dialog
      title="交付商交付审核"
      :visible.sync="dialogDelivery"
      width="707px"
      :before-close="handleClose"
    >
      <div class="dialogAudit">
        <div class="main2">
          <el-form
            :model="deliveryForm"
            :rules="deliveryRules"
            ref="deliveryForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="title">审核信息</div>
            <el-form-item label="审核状态：" prop="nextStatus">
              <el-select v-model="deliveryForm.nextStatus" placeholder="请选择">
                <el-option label="审核通过" value="1070"></el-option>
                <!-- <el-option label="审核不通过" value="1300"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="审核备注：" prop="auditContent">
              <el-input
                type="textarea"
                v-model="deliveryForm.auditContent"
                rows="4"
                resize="none"
                placeholder="请输入多行"
              ></el-input>
            </el-form-item>
            <div class="title">交付商交付相关信息</div>
            <el-form-item label="交付内容：" prop="delivererContent">
              <el-input
                type="textarea"
                v-model="deliveryForm.delivererContent"
                rows="4"
                resize="none"
                placeholder="请输入多行"
              ></el-input>
            </el-form-item>
            <el-form-item label="收件人：" prop="mailTo">
              <el-input v-model="deliveryForm.mailTo" placeholder="请输入单行"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="mailMobile">
              <el-input v-model="deliveryForm.mailMobile" placeholder="请输入单行"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址：" prop="mailAddr">
              <el-input
                type="textarea"
                v-model="deliveryForm.mailAddr"
                rows="4"
                resize="none"
                placeholder="请输入多行"
              ></el-input>
            </el-form-item>
            <el-form-item label="发票接收邮箱：" prop="mailEmail">
              <el-input v-model="deliveryForm.mailEmail" placeholder="请输入单行"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitDForm('deliveryForm')">确定</el-button>
              <el-button @click="resetDForm('deliveryForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog :visible.sync="dialogDetails" width="1080px" :before-close="handleClose">
      <div class="checkDetails">
        <el-tabs type="border-card">
          <el-tab-pane label="申请信息">
            <div class="main">
              <div class="title">申请详情</div>
              <div class="content">
                <div class="list">
                  <span>发票申请编号：{{invoiceObj.applyNo}}</span>
                  <span>发票类型：{{invoiceObj.type}}</span>
                  <span>申请时间：{{invoiceObj.invoiceTime}}</span>
                </div>
                <div class="list">
                  <span>价税合计总额（元）：{{invoiceObj.invoiceAmount}}</span>
                  <span style="margin-right: 0px;">个税：{{invoiceObj.personalIncomeTax}}</span>
                </div>
                <div class="list">
                  <span>增值税：{{invoiceObj.valueAddedTax}}</span>
                  <span>附加税：{{invoiceObj.additionalTax}}</span>
                  <span>开票内容：{{invoiceObj.invoiceContent}}</span>
                </div>
                <div class="list">
                  <span class="span">结算单：</span>
                  <div>
                    <img :src="invoiceObj.settleImg" alt />
                  </div>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">发票购买方</div>
              <div class="content">
                <div class="list">
                  <span>商户名称：{{invoiceObj.merchantName}}</span>
                  <span>纳税人识别号：{{invoiceObj.merchantCreditCode}}</span>
                  <span style="margin-right: 0px;">地址：{{invoiceObj.merchantAddr}}</span>
                </div>
                <div class="list">
                  <span>电话：{{invoiceObj.merchantMobile}}</span>
                  <span>开户行：{{invoiceObj.merchantBank}}</span>
                  <span>对公账户：{{invoiceObj.merchantAccount}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">发票销售方</div>
              <div class="content">
                <div class="list">
                  <span>个体工商户名称：{{invoiceObj.businessName}}</span>
                  <span>纳税人识别号：{{invoiceObj.businessmenCreditCode}}</span>
                  <span style="margin-right: 0px;">银行开户：{{invoiceObj.businessBank}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">邮寄地址</div>
              <div class="content">
                <div class="list">
                  <span>收件人姓名：{{invoiceObj.mailTo}}</span>
                  <span>联系电话：{{invoiceObj.mailMobile}}</span>
                  <span style="margin-right: 0px;">详细地址：{{invoiceObj.mailAddr}}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="业务办理">
            <div class="main">
              <div class="title">业务分配</div>
              <div class="content" v-if="invoiceObj.deliverer">
                <div class="list">
                  <span>业务交付商：{{invoiceObj.deliverer.delivererName}}</span>
                  <span>业务金额(元):{{invoiceObj.deliverer.delivererAmount}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">审核详情</div>
              <div class="content" v-if="invoiceObj.deliverer">
                <div class="list" v-if="invoiceObj.invoice">
                  <span>审核状态：{{invoiceObj.invoice.statusName}}</span>
                </div>
                <div class="list">
                  <span>审核内容：{{invoiceObj.deliverer.auditContent}}</span>
                </div>
                <div class="list">
                  <span>交付内容：{{invoiceObj.deliverer.delivererContent}}</span>
                </div>
                <div class="list">
                  <span>收件人：{{invoiceObj.deliverer.mailTo}}</span>
                </div>
                <div class="list">
                  <span>联系电话：{{invoiceObj.deliverer.mailMobile}}</span>
                </div>
                <div class="list">
                  <span>邮寄地址：{{invoiceObj.deliverer.mailAddr}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">交付商交付信息</div>
              <div class="content" v-if="invoiceObj.deliverer">
                <div class="list">
                  <span>快递单号：{{invoiceObj.deliverer.delivererMailNo}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">平台交付信息</div>
              <div class="content" v-if="invoiceObj.deliverer">
                <div class="list">
                  <span>快递单号：{{invoiceObj.deliverer.platformMailNo}}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已开发票">
            <div class="main">
              <div class="title">发票详情</div>
              <div class="content" v-if="invoiceObj.invoice">
                <div class="list">
                  <span>发票编号：{{invoiceObj.invoice.applyNo}}</span>
                  <span>开票时间：{{invoiceObj.invoice.invoiceTime}}</span>
                  <span style="margin-right: 0px;">快递单号：{{invoiceObj.invoice.mailNo}}</span>
                </div>
                <!-- <div class="list"><span class="span">支付凭证：</span><div><img :src="invoiceObj.invoice" alt=""></div></div> -->
              </div>
            </div>
            <div class="main">
              <div class="title">发票照片</div>
              <div class="photo" v-if="invoiceObj.invoice">
                <img :src="invoiceObj.invoice.invoiceImg" alt />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="完税证明">
            <div class="main">
              <div class="title">完税证明详情</div>
              <div class="content" v-if="invoiceObj.invoice">
                <div class="list">
                  <span>完税批号：{{invoiceObj.invoice.taxNo}}</span>
                  <span style="margin-right: 0px;">完税时间：{{invoiceObj.invoice.taxTime}}</span>
                </div>
              </div>
            </div>
            <div class="main">
              <div class="title">完税证明图片</div>
              <div class="photo" v-if="invoiceObj.invoice">
                <img :src="invoiceObj.invoice.taxVoucher" alt />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      total: 10,
      pageSzie: 10,
      invoiceTime: "",
      applyNo: "",
      type: "",
      status: "",
      tableData: [],
      statusOptions: [
        {
          value: "1000",
          label: "待审核"
        },
        {
          value: "1010",
          label: "申请审核失败"
        },
        {
          value: "1020",
          label: "待分配"
        },
        {
          value: "1030",
          label: "待处理"
        },
        {
          value: "1050",
          label: "已开具"
        },
        {
          value: "1070",
          label: "审核通过"
        },
        {
          value: "1090",
          label: "已完成"
        },
        {
          value: "1300",
          label: "交付审核失败"
        }
      ],
      typeOptions: [
        {
          value: "20",
          label: "增值税专用发票"
        },
        {
          value: "10",
          label: "普通发票"
        },
        {
          value: "30",
          label: "电子发票"
        }
      ],
      options: [],
      dialogDelivery: false,
      dialogAudit: false,
      dialogOrder: false,
      dialogDetails: false,
      invoiceObj: {},
      deliveryForm: {
        id: "",
        nextStatus: "",
        auditContent: "",
        delivererContent: "",
        mailAddr: "",
        mailMobile: "",
        mailTo: "",
        mailEmail: ""
      },
      deliveryRules: {
        nextStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" }
        ],
        auditContent: [
          { required: true, message: "请填写审核备注", trigger: "blur" }
        ],
        delivererContent: [
          { required: true, message: "请填写交付内容", trigger: "blur" }
        ],
        mailAddr: [
          { required: true, message: "请填写邮寄地址", trigger: "blur" }
        ],
        mailMobile: [
          { required: true, message: "请输入邮寄电话", trigger: "blur" },
          { min: 0, max: 11, message: "长度在11个字符", trigger: "blur" }
        ],
        mailTo: [
          { required: true, message: "请输入邮寄人姓名", trigger: "blur" }
        ]
      },
      DeliveryAuditPrice: null,
      distributionOptions: [],
      distributionForm: {
        id: "", // 商户id
        nextStatus: "1030",
        merchantId: "",
        delivererId: "", // 交付商id
        delivererName: "", // 交付商名称
        delivererAmount: "" // 交付商分成金额
      },
      rulesTwo: {
        delivererAmount: [
          { required: true, message: "请输入交付商分成金额", trigger: "blur" }
        ],
        delivererId: [
          { required: true, message: "请选择交付商名称", trigger: "change" }
        ]
      },
      auditForm: {
        nextStatus: "",
        isPay: "0",
        remark: ""
      },
      auditRules: {
        nextStatus: [
          { required: true, message: "请选择发票状态", trigger: "change" }
        ],
        isPay: [
          { required: true, message: "请选择支付状态", trigger: "change" }
        ],
        remark: [{ required: true, message: "请填写审核备注", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.distributionOptions =
      JSON.parse(localStorage.getItem("deliveryList")) || [];
    console.log(this.distributionOptions, "ssssssssssssssss");
    this.handlePagePost();
  },
  methods: {
    // 完成
    completeClick(row) {
      post(api.platformAssignment, {
        id: row.id,
        nextStatus: "1090"
      }).then(
        d => {
          console.log(d);
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success"
            });
            this.handlePagePost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 交付审核
    deliveryHandleClick(row) {
      this.dialogDelivery = true;
      this.deliveryForm.id = row.id;
    },
    // 审核确认
    submitDForm(formName) {
      console.log(this.deliveryForm);
      this.$refs[formName].validate(valid => {
        if (valid) {
          post(api.platformAssignment, this.deliveryForm).then(
            d => {
              console.log(d);
              if (d.status === 0) {
                console.log(d, "!!!!!!!!!!!!");
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.dialogDelivery = false;
                this.$refs[formName].resetFields();
                this.handlePagePost();
              }
            },
            err => {
              //error callback
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 审核取消
    resetDForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogDelivery = false;
    },
    newProgress(row) {
      console.log(row);
      this.dialogOrder = true;
      this.distributionForm.id = row.id;
      this.distributionForm.merchantId = row.merchantId;
      this.DeliveryAuditPrice = row.serviceCharge;
    },
    // 选择交付商
    distributionChange(val) {
      console.log(val);
      console.log(this.DeliveryAuditPrice);
      var data = this.distributionOptions;
      for (let i = 0; i < data.length; i++) {
        if (val == data[i].value) {
          this.distributionForm.delivererName = data[i].label;
          this.distributionForm.delivererAmount = (
            (this.DeliveryAuditPrice * data[i].divide) /
            100
          ).toFixed(2);
        }
      }
    },
    // 业务分配
    distributionSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          post(api.platformAssignment, this.distributionForm).then(
            d => {
              console.log(d, "关闭");
              if (d.status === 0) {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.handlePagePost();
                this.$refs[formName].resetFields();
                this.dialogOrder = false;
              }
            },
            err => {
              //error callback
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    distributionResetForm(formName) {
      this.distributionForm = {
        id: "", // 商户id
        delivererId: "", // 交付商id
        delivererName: "", // 交付商名称
        delivererAmount: "" // 交付商分成金额
      };
      this.$refs[formName].resetFields();
      this.dialogOrder = false;
    },
    auditHandleClick(row) {
      this.dialogAudit = true;
      this.invoiceObj = row;
      this.auditForm.id = row.id;
    },
    // 审核确认
    submitForm(formName) {
      console.log(this.auditForm);
      if (this.auditForm.isPay == "0") {
        this.$message({
          message: "请确认付款",
          type: "warning"
        });
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          post(api.platformAssignment, this.auditForm).then(
            d => {
              console.log(d);
              if (d.status === 0) {
                console.log(d, "!!!!!!!!!!!!");
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.dialogAudit = false;
                this.$refs[formName].resetFields();
                this.handlePagePost();
              }
            },
            err => {
              //error callback
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 审核取消
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogAudit = false;
    },
    reset() {
      this.invoiceTime = "";
      this.applyNo = "";
      this.type = "";
      this.status = "";
      this.handlePagePost();
    },
    handlePagePost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.queryApplyInvoices, {
        pageIndex: size || 1,
        pageSize: this.pageSzie,
        invoiceTime: this.invoiceTime,
        applyNo: this.applyNo,
        type: this.type,
        status: this.status
      }).then(
        d => {
          console.log(d);
            loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.handlePagePost();
    },
    handleCurrentChange(size) {
      console.log(size);
      this.handlePagePost(size);
    },
    handleClick(row) {
      console.log(row);
      post(api.queryInvoice, {
        id: row.id
      }).then(
        d => {
          console.log(d);
          if (d.status === 0) {
            console.log(d, "????????????");
            this.dialogDetails = true;
            this.invoiceObj = d.data;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //   })
      //   .catch(_ => {});
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.invoiceApplyFor {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 120px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
  .dialogFromSpan {
    margin: 0 48px;
  }
  .dialogAudit {
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;
    .main {
      width: 100%;
      overflow: hidden;
      padding: 9px 21px;
      box-sizing: border-box;
      .items {
        width: 100%;
        height: 88px;
        background: rgba(216, 216, 216, 0.22);
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 0.22);
        .item {
          width: 100%;
          line-height: 44px;
          display: flex;
          span {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
      .items2 {
        width: 100%;
        margin-top: 10px;
        overflow: hidden;
        .text {
          text-align: left;
          padding-bottom: 20px;
        }
        span {
          width: 100px;
          float: left;
          text-align: left;
        }
        .img {
          float: left;
          width: 384px;
          height: 179px;
          background: rgba(216, 216, 216, 0.34);
          border-radius: 4px;
          border: 1px solid rgba(151, 151, 151, 0.34);
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .main2 {
      width: 430px;
      overflow: hidden;
      padding: 9px 21px;
      box-sizing: border-box;
      text-align: left;
      .title {
        width: 100%;
        margin-bottom: 25px;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .list {
        width: 100%;
        overflow: hidden;
        margin-top: 10px;
        span {
          float: left;
          width: 85px;
          height: 46px;
          line-height: 46px;
          text-align: right;
        }
        div {
          float: left;
          width: 233px;
        }
      }
    }
    .bottom {
      width: 100%;
      text-align: right;
    }
  }
  .checkDetails {
    width: 100%;
    .main {
      width: 100%;
      height: auto;
      background: rgba(244, 244, 244, 0.78);
      border-radius: 6px;
      padding: 10px 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .title {
        width: 100%;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
      }
      .content {
        width: 100%;
        padding: 10px 18px;
        box-sizing: border-box;
        text-align: left;
        padding-bottom: 0px;
        .list {
          width: 100%;
          overflow: hidden;
          margin-bottom: 10px;
          span {
            margin-right: 70px;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .span {
            margin-right: 10px;
            float: left;
          }
          div {
            float: left;
            width: 139px;
            height: 50px;
            background: rgba(227, 227, 227, 1);
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .photo {
        width: 881px;
        height: 267px;
        margin: 20px auto;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        border: 1px solid rgba(220, 220, 220, 1);
        padding: 10px;
        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/trading/invoice/invoiceApplyFor.vue